import { render, staticRenderFns } from "./SMSAutomation.vue?vue&type=template&id=5de22b34&"
import script from "./SMSAutomation.vue?vue&type=script&lang=js&"
export * from "./SMSAutomation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports